export default __webpack_public_path__ + "static/media/photo_5282747746622312916_y.d1e9da7c.jpg";